import React, { useState, useEffect, useContext, useMemo } from 'react';
import {
  Form,
  Card,
  Button,
  // Tabs,
  // Tab,
  Accordion,
  // Alert,
} from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { schemas } from 'utils/schemas';
import { Ctx } from 'components/CtxFormFields/CtxInputs';
import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';
import useErrorState, { translateError } from 'utils/hooks/useErrorState';
import { changeTypeBySchema } from 'utils/changeTypesBySchema';

import { requestGetLanesCloud } from './requests';
import { triPosFields, triPosDefaults } from './formShape';

function TriPos() {
  const { level } = useParams();
  const formContext = useContext(Ctx);
  const { loading, integrationState, setEnabledSave } = formContext.values;
  const values = useMemo(
    () => ({ ...triPosDefaults, ...integrationState }),
    [triPosDefaults, integrationState],
  );
  const key = 'cloud';
  const schema = schemas['vantiv-tripos-golang-microservice'];

  const validationObject = {
    ...triPosFields.mandatory,
    ...triPosFields.additional,
    ...triPosFields.direct,
    ...triPosFields.cloud,
  };

  if (level !== 'Pos') {
    delete validationObject.TriPosCloudUrl;
    delete validationObject.TriPosDirectUrl;
    delete validationObject.LaneId;
  }
  if (integrationState.TriPosCloud) {
    delete validationObject.TriPosCloudUrl;
  } else {
    delete validationObject.TriPosDirectUrl;
  }

  const { errors, hasErrors } = useErrorState(values, validationObject);

  const onChange = (k, value) => {
    const parsedValue = changeTypeBySchema(schema, k, value);
    formContext.onChange({ [k]: parsedValue });
  };

  const [laneIds, setLaneIds] = useState([]);
  const urls = [
    'https://tripos.worldpay.com',
    'https://tripos.vantiv.com',
    'https://triposcert.worldpay.com',
    'https://triposcert.vantiv.com',
  ];

  const [showMoreSettings, setShowMoreSettings] = useState(false);

  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [errors]);

  useEffect(() => {
    requestGetLanesCloud()
      .then(({ data }) => setLaneIds(data))
      .catch((err) => console.error(err));
  }, [key]);

  const options = useMemo(
    () => [
      { name: 'Select Lane ID', value: '' },
      ...laneIds.map((lane) => ({
        name: lane.terminalId,
        value: lane.laneId,
      })),
    ],
    [laneIds],
  );

  if (loading) return <div>Loading...</div>;

  return (
    <div className="d-flex flex-fill flex-column mt-3">
      <Ctx.Provider
        value={useMemo(() => ({ values, onChange }), [values, onChange])}
      >
        <Card className=" my-3">
          <Card.Header>TriPOS Basic Credentials</Card.Header>
          <Card.Body>
            <Form>
              {Object.values(triPosFields.mandatory).map(
                ({ validate, ...rest }) => (
                  <RenderFormItem
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...rest}
                    size="md"
                    key={rest.id}
                    name={rest.id}
                    error={translateError(errors[rest.id], null)}
                  />
                ),
              )}
              <Accordion>
                <Accordion.Collapse eventKey="0" in={showMoreSettings}>
                  <>
                    {Object.values(triPosFields.additional).map(
                      ({ validate, ...rest }) => (
                        <RenderFormItem
                          /* eslint-disable-next-line react/jsx-props-no-spreading */
                          {...rest}
                          size="md"
                          key={rest.id}
                          name={rest.id}
                          error={translateError(errors[rest.id], null)}
                        />
                      ),
                    )}
                  </>
                </Accordion.Collapse>
                <Button
                  variant="link"
                  eventKey="0"
                  onClick={() => setShowMoreSettings(!showMoreSettings)}
                >
                  {`Show ${showMoreSettings ? 'less' : 'more'} settings`}
                </Button>
              </Accordion>
            </Form>
          </Card.Body>
        </Card>
        <Card className=" my-3">
          <Card.Body>
            <Form className="my-3">
              {Object.values(triPosFields.cloud).map(
                ({ validate, ...rest }) => {
                  const isReadOnly = rest.id === 'TriPosCloudUrl';
                  return (
                    <RenderFormItem
                      /* eslint-disable-next-line react/jsx-props-no-spreading */
                      {...rest}
                      size="md"
                      key={rest.id}
                      name={rest.id}
                      readOnly={isReadOnly}
                      error={translateError(errors[rest.id], null)}
                      options={
                        rest.type === 'select' && rest.id === 'TriPosCloudUrl'
                          ? urls
                          : options
                      }
                    />
                  );
                },
              )}
            </Form>
          </Card.Body>
        </Card>
      </Ctx.Provider>
    </div>
  );
}

export default TriPos;
